// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { TankListComponent } from 'src/app/modules/tank/pages/tank-list/tank-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: TankListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class TankRoutingModule { }
